import axios from "axios"
import { Api_url } from "../../common/api_url"
import { API_XANO_AUTH_BASE_URL, API_XANO_BASE_URL, API_XANO_RAZORPAY_BASE_URL } from "../../config/api_config"
import { axiosAuth, axiosNoAuth } from "../../config/axiosInstances"
import { SET_USER_DISCOUNT } from "./types"

export function generateOrderId(token, product_id, successCallback, errorCallback) {
    return async function (dispatch) {
        console.log(product_id);
        try {
            const response = await axiosAuth.post(API_XANO_RAZORPAY_BASE_URL + Api_url.CreateRazorpayOrderId, {
                headers: {
                    Authorization: `Bearer ${token}`
                },
                product_id,
                activity_source : 'webapp'
            })

            successCallback && successCallback(response.data)
        } catch (err) {

            console.log(err)
            errorCallback && errorCallback(err)
        }
    }
}

export function generateRazorpayTranscript(token, object, successCallback, errorCallback) {
    return async function (dispatch) {
        try {
            const response = await axiosAuth.post(API_XANO_RAZORPAY_BASE_URL + Api_url.CreateRazorpayTransaction, {
                headers: {
                    Authorization: `Bearer ${token}`
                },
                transaction_object: object
            })

            successCallback && successCallback(response.data)
        } catch (err) {

            console.log(err)
            errorCallback && errorCallback(err)
        }
    }
}


export function getProductPricing(user_id, successCallback, errorCallback) {
    return async function (dispatch) {
        try {

            const response = await axiosAuth.get(API_XANO_BASE_URL + Api_url.GetPlans, {
                params: {
                    user_id
                }
            })
            successCallback && successCallback(response.data);

        }
        catch (error) {
            console.log(error);
            errorCallback && errorCallback(error);
        }
    }
}

export function getProductPricingForCoins(product_type, subscription_type, successCallback, errorCallback) {
    return async function (dispatch) {
        try {

            const response = await axiosAuth.get(API_XANO_BASE_URL + Api_url.GetPrice, {
                params: {
                    product_type, 
                    subscription_type
                }
            })
            successCallback && successCallback(response.data);

        }
        catch (error) {
            console.log(error);
            errorCallback && errorCallback(error);
        }
    }
}

export function getFaqData(successCallback, errorCallback) {
    return async function (dispatch) {
        try {

            const response = await axiosAuth.get(API_XANO_BASE_URL + Api_url.GetFaqsData)

            successCallback && successCallback(response.data);


        }
        catch (error) {
            console.log(error);
            errorCallback && errorCallback(error);
        }
    }
}

export function getReviewData(successCallback, errorCallback) {
    return async function (dispatch) {
        try {

            const response = await axiosAuth.get(API_XANO_BASE_URL + Api_url.GetReviewData);
            successCallback && successCallback(response.data);

        }
        catch (error) {
            console.log(error);
            errorCallback && errorCallback(error);

        }
    }



}

export function getToggleDiscount(successCallback, errorCallback) {
    return async function (dispatch) {
        try {

            const response = await axiosAuth.get(API_XANO_BASE_URL + Api_url.GetToggleDiscount)
            successCallback(response.data);

        }
        catch (err) {
            console.log(err);
            errorCallback && errorCallback(err);
        }


    }
}

export function getHigestDiscount(user_id, successCallback, errorCallback) {
    return async function (dispatch) {
        try {
            const response = await axiosAuth.get(API_XANO_BASE_URL + Api_url.GetHighestDiscount, {
                params: {
                    user_id
                }
            })
            // setDiscountTime(response?.data?.expires_at)
            dispatch({ type: SET_USER_DISCOUNT, payload: response.data })

            successCallback && successCallback(response.data);

        }
        catch (err) {
            console.log(err);
            errorCallback && errorCallback(err);
        }

    }
}

export function SupportRequest(user_id, age, career_goal, available_timeslot, type, successCallback, errorCallback) {
    return async function (dispatch) {
        try {
            const response = await axiosAuth.post(API_XANO_BASE_URL + Api_url.SendSupportRequest, {
                user_id,
                age,
                career_goal,
                available_timeslot,
                type
            })
            console.log(response);

            successCallback && successCallback(response.data);
        }
        catch (err) {
            console.log(err);
            errorCallback && errorCallback(err);
        }
    }
}

export function checkEligibity(user_id, successCallback, errorCallback) {
    return async function (dispatch) {
        try {
            const response = await axiosAuth.get(API_XANO_BASE_URL + Api_url.GetEligibility, {
                params: {
                    user_id
                }
            });

            successCallback && successCallback(response.data);

        }
        catch (err) {
            console.log(err);
            errorCallback && errorCallback(err);
        }


    }
}

export function getBookingProduct(successCallback, errorCallback) {
    return async function (dispatch) {
        try {
            const response = await axiosAuth.get(API_XANO_BASE_URL + Api_url.GetBookingProduct, {
                params: {
                    products_id: 18
                }
            })
            successCallback && successCallback(response.data);
        }
        catch (err) {
            console.log(err);
            errorCallback && errorCallback(err);
        }
    }
}

export function getProductById(products_id,successCallback , errorCallback){
    return async function ( dispatch){
        try{
            const response = await axiosAuth.get(API_XANO_BASE_URL + Api_url.GetBookingProduct, {
                params : {
                    products_id 
                }
            })
            successCallback && successCallback(response.data);
        }
        catch (err) {
            console.log(err);
            errorCallback && errorCallback(err);
        }
    }
}

export function createLeadScore(user_id, activity_type, razorpay_order_id = null, activity_source = 'webapp', successCallback, errorCallback) {
    return async function (dispatch) {
        try {

            const response = await axiosNoAuth.post(API_XANO_BASE_URL + Api_url.LeadScoring, {
                user_id,
                activity_type,
                activity_source,
                razorpay_order_id 

            })

            successCallback && successCallback(response.data)

        }
        catch (err) {
            console.log(err);
            errorCallback && errorCallback(err)
        }
    }
}

export function getBenefitsSection(user_id, successCallback , errorCallback){
    return async function(dispatch){
        try{
            const response = await axiosNoAuth.get('https://xgfy-czuw-092q.m2.xano.io/api:moWASRzn' + Api_url?.GetBenefitSecton,{ params : user_id});

            successCallback && successCallback(response.data);

        }
        catch(err){
            errorCallback && errorCallback(err);
        }
    }
}

export function getUserStoriesAndReviews(successCallback , errorCallback){
    return async function(dispatch){
        try{
            const response = await axiosNoAuth.get('https://xgfy-czuw-092q.m2.xano.io/api:HYL0rVog/user_stories_and_reviews');
            
            successCallback && successCallback(response.data);
        }
        catch(err){
            errorCallback && errorCallback(err);
        }
    }
}
export function getPricingGoal(successCallback , errorCallback){
    return async function(dispatch){
        try{
            const response = await axiosAuth.get(API_XANO_BASE_URL + Api_url.GetPricingGoal);
            
            successCallback && successCallback(response.data);
        }
        catch(err){
            errorCallback && errorCallback(err);
        }
    }
}

export function sendPricingGoal(product_plans_id , successCallback , errorCallback){
    return async function(dispatch){
        try{
            const response = await axiosAuth.post(API_XANO_BASE_URL + Api_url.SendPricingGoal,{
                product_plans_id
            });
            
            successCallback && successCallback(response.data);
        }
        catch(err){
            errorCallback && errorCallback(err);
        }
    }
}